import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    CircularProgressbar,
    buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const CustomerHealthCharts = ({ endPoint }) => {

  let branch_code_from_local_storage = localStorage.getItem("currentSelectedDepartment");
  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"


    const [chartData, setChartData] = useState(null);
    const [loading, setLoading] = useState(true);

    const todayDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    const fetchChartData = async () => {
        try {
            const response = await axios.get(
                `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/${branch_code_from_local_storage}/${endPoint}/2024-01-01/${todayDate}/-/-/-/-/-`
            );
            setChartData(response.data[0]);
            console.log("Customer Health Summary:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchChartData();
    }, [endPoint]);

    const renderChart = (value, label, color) => (
        <div style={{ width: 180, margin: 50, textAlign: "center" }}>
            <CircularProgressbar
                value={value}
                text={`${value}`}
                strokeWidth={12}
                styles={buildStyles({
                    strokeLinecap: "round",
                    pathColor: color,
                    trailColor: "#eee",
                    textColor: "#333",
                    textSize: "14px",
                })}
            />
            <div style={{ marginTop: 12, marginBottom: 16, fontSize: 16 }}>
                <strong>{label}</strong>
            </div>
        </div>
    );

    if (loading || !chartData) return <p>Loading...</p>;

    return (
<div
  className="flex flex-wrap justify-center items-center gap-4 pb-3"
>
  {endPoint === "Customer_Health_Summary" ? (
    <>
      {renderChart(chartData["Total Active Customers"], "Active Customers", "#28a745")}
      {renderChart(chartData["New Customers (6M)"], "New Customers", "#17a2b8")}
      {renderChart(chartData["Inactive (3M)"], "Inactive", "#dc3545")}
      {renderChart(chartData["Reactivated (3M)"], "Reactivated", "#ffc107")}
    </>
  ) : endPoint === "6MONTH_SALES_COMP" ? (
    <>
      {renderChart(chartData["Current6MonthsSales"], "Current 6 Months Sales", "#28a745")}
      {renderChart(chartData["Previous6MonthsSales"], "Previous 6 Months Sales", "#17a2b8")}
      {renderChart(chartData["GrowthPercent"], "Growth %", "#1664C0")}
    </>
  ) : (
    <p className="text-center text-gray-500">No chart available for this endpoint.</p>
  )}
</div>

    )
}

export default CustomerHealthCharts;